import { render, staticRenderFns } from "./NotificationSticker.vue?vue&type=template&id=623938d8&scoped=true"
import script from "./NotificationSticker.vue?vue&type=script&lang=js"
export * from "./NotificationSticker.vue?vue&type=script&lang=js"
import style0 from "./NotificationSticker.vue?vue&type=style&index=0&id=623938d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623938d8",
  null
  
)

export default component.exports